export default "__VITE_ASSET__C6NthvOL__"